<template>
  <div class="row" v-if="product">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="addVariation">
          <l-checkbox v-model="createInstances">Variation Instanzen erstellen</l-checkbox>
          <div v-if="createInstances">
            <fg-input label="Menge"
              type="text"
              v-model="quantity"
            />
            <div class="form-group has-label">
              <warehouse-select
                v-model="warehouse"
                :options="warehouses"
              />
            </div>
            <hr>
          </div>
          <div v-for="productFeature in product.product_features" :key="productFeature.id">
            <label><strong>{{ productFeature.custom_category.name }}</strong></label>
            <div class="form-group has-label">
              <label>{{ productFeature.feature.name }}</label>
              <template v-if="productFeature.feature.type === 'dropdown'">
                <multiselect v-model="productFeature.feature_option"
                  :options="productFeature.feature.options"
                  track-by="id"
                  label="value"
                  :multiple="true"
                />
              </template>
              <template v-if="productFeature.feature.type === 'textinput' || productFeature.feature.type === 'number'">
                <input class="form-control" v-model="productFeature.feature_option_value"
                  :type="productFeature.feature.type === 'textinput' ? 'text' : 'number'"
                  step=".5"
                >
              </template>
              <template v-if="productFeature.feature.type === 'textarea'">
                <textarea class="form-control" v-model="productFeature.feature_option_value"></textarea>
              </template>
              <template v-if="productFeature.feature.type === 'checkbox'">
                <el-checkbox-group v-model="productFeature.feature_option">
                  <el-checkbox
                    v-for="bla in productFeature.feature.options"
                    :key="bla.id"
                    :label="bla.value"
                  />
                </el-checkbox-group>
              </template>
              <template v-if="productFeature.feature.type === 'date'">
                <el-date-picker
                  v-model="productFeature.feature_option_value"
                  format="dd.MM.yyyy"
                  value-format="yyyy-MM-dd"
                  :clearable="false"
                  :picker-options="{ firstDayOfWeek: 1 }"
                />
              </template>
              <div class="text-danger invalid-feedback" style="display: block;"
                v-if="productFeature.feature.is_required && showRequiredFeatureError"
              >
                Eigenschaft muss ausgefüllt werden.
              </div>
            </div>
          </div>
          <button class="btn btn-primary" type="submit">
            Hinzufügen
          </button>
        </form>
      </card>
    </div>
    <div class="col-sm-6">
      <card class="stacked-form">
        <template slot="header"><h4 class="card-title">Variationen</h4></template>
        <table class="table" v-if="baseProduct.variations.length">
          <thead>
            <tr>
              <th>Name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="variation in baseProduct.variations.slice().reverse()" :key="variation.id">
              <td>
                <router-link :to="`/products/${variation.id}`">
                  {{ variation.name }}
                </router-link>
              </td>
              <td>
                <ul style="margin-bottom: 0;">
                  <li v-for="stringRep in variation.stringRep" :key="stringRep" v-text="stringRep"></li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>Noch keine Variationen für dieses Produkt vorhanden</p>
      </card>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import WarehouseSelect from 'src/components/warehouse-select.vue'

export default {
  components: { WarehouseSelect },
  data () {
    return {
      baseProduct: null,
      product: null,
      quantity: 1,
      showRequiredFeatureError: false,
      warehouses: [],
      warehouse: this.$store.state.filters.warehouse,
      createInstances: false
    }
  },
  methods: {
    addVariation () {
      const reqData = {
        quantity: this.quantity,
        product_features: [],
        warehouse_id: this.warehouse ? this.warehouse.id : '',
        create_instances: this.createInstances
      }

      this.product.product_features.forEach((feature) => {
        reqData.product_features.push({
          'custom_category_id': feature.custom_category_id,
          'feature_id': feature.feature_id,
          'feature_option': Array.isArray(feature.feature_option) ? feature.feature_option.map(({ id }) => id) : null,
          'feature_option_value': feature.feature_option_value,
          'multiple': feature.feature.multiple
        })
      })

      this.$http.post(`/products/${this.$route.params.id}/variations/fast`, reqData).then(({ data }) => {
        this.$notify({
          message: 'Die Variationen wurden erfolgreich erfasst.',
          type: 'success'
        })

        this.$router.push(`/products/${this.$route.params.id}`)
      })
    }
  },
  created () {
    this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
      data.product_features.forEach(productFeature => {
        if (productFeature.feature.type === 'dropdown' && productFeature.feature_option) {
          productFeature.feature_option = [productFeature.feature_option]
        }
      })
      this.baseProduct = data
      this.product = cloneDeep(data)
    })
    this.$http.get('/warehouses').then(({ data }) => { this.warehouses = data })
  }
}
</script>

<style>
</style>
